import * as allThemes from "@/theme/themes"
import vuetify from "@/plugins/vuetify"
import { computed } from "vue"
export function useThemeHelper() {
  const themeNames = Object.keys(allThemes).map((theme) => {
    return { value: theme, title: theme }
  })
  const name = computed({
    get: () => vuetify?.theme.global.name.value,
    set: (value: string) => vuetify?.theme.change(value),
  })
  const isDark = computed(() => vuetify?.theme.global.current.value.dark)
  const colors = computed(() => vuetify?.theme.global.current.value.colors)
  return { themeNames, name, isDark, colors }
}
